import React from 'react';

import { PrimaryButton } from '@/components/ui/buttons/PrimaryButton';
import { ExportDropdown } from '@/components/ui/filters';
import { IconScout } from '@/components/ui/images/IconScout';
import Table from '@/components/ui/tables/Table';
import { useTranslation } from '@/i18n';
import { PermissionGuard } from '@/components/layout';
import { useWorkingDayList } from '@/hooks/shift/useWorkingDayList';
import { useWorkingDayExport } from '@/hooks/shift/useWorkingDayExport';


export const WorkingDaysTab: React.FC = () => {
  const { t: translate } = useTranslation();
  const {
    rows,
    total,
    page,
    pageSize,
    setPage,
    setPageSize,
    columns,
    actions,
    onSearch,
    onEnterSearch,
    onSortChange,
    isLoading,
    openCreatePanel,
  } = useWorkingDayList();

  const { onExport, isExporting } = useWorkingDayExport();

  return (
    <div className="flex flex-col gap-6" data-testid="working-days-tab">
      {/* Header actions */}
      <div className="flex justify-between items-center">
        <PermissionGuard action="create">
          <PrimaryButton
            iconLeft={<IconScout name="plus" />}
            onClick={openCreatePanel}
          >
            {translate('schedule:workingDay.actions.create')}
          </PrimaryButton>
        </PermissionGuard>

        <ExportDropdown
          onExport={onExport}
          placement="right"
          isLoading={isExporting}
          availableFormats={['EXCEL']}
        />
      </div>

      {/* Table */}
      <Table
        columns={columns}
        data={rows}
        totalRows={total}
        isLoading={isLoading}
        searchable
        onSearch={onSearch}
        onEnterSearch={onEnterSearch}
        serverSideSort
        onSortChange={onSortChange}
        actions={actions}
        pagination={{
          page,
          pageSize,
          total,
          onChange: setPage,
          onPageSizeChange: setPageSize,
        }}
        data-testid="working-days-table"
      />
    </div>
  );
};

export default WorkingDaysTab;
